import api from "./index";

export interface TestQuestionsListParams {
  id: string;
  offset?: number;
  limit?: number;
  randomize?: boolean;
  options?: any;
}

export default (params: TestQuestionsListParams, options?: any) => {
  return api.TestApi.listQuestions(
    params.id,
    params.offset,
    params.limit,
    params.randomize,
    options
  );
};
